// extracted by mini-css-extract-plugin
export default {"link":"Link_link__X1Dgy","linkUnderlined":"Link_linkUnderlined__uVMR7","primary":"Link_primary__TTEbU","secondary":"Link_secondary__DTlSj","tertiary":"Link_tertiary__rEJKx"};